import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum DefectTypeId {
  SHOWER = 1,
  TV = 2,
  KEY = 3,
  HEATING = 4,
  LIGHTING = 5,
  OTHER = 6,
  TOILET = 7,
  LONG_TERM = 8,
}

export class DefectType extends Codebook<DefectTypeId> {
  static readonly SHOWER = new DefectType(DefectTypeId.SHOWER, () => $t('Shower'))
  static readonly TV = new DefectType(DefectTypeId.TV, () => $t('TV'))
  static readonly KEY = new DefectType(DefectTypeId.KEY, () => $t('Key'))
  static readonly HEATING = new DefectType(DefectTypeId.HEATING, () => $t('Heating'))
  static readonly LIGHTING = new DefectType(DefectTypeId.LIGHTING, () => $t('Lighting'))
  static readonly OTHER = new DefectType(DefectTypeId.OTHER, () => $t('Other'))
  static readonly TOILET = new DefectType(DefectTypeId.TOILET, () => $t('Toilet'))
  static readonly LONG_TERM = new DefectType(DefectTypeId.LONG_TERM, () => $t('Long-term'))

  private constructor(
    id: DefectTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
